import { WebPlugin } from '@capacitor/core';
export class CapacitorTipsWeb extends WebPlugin {
    async listProducts() {
        // Implement the listProducts logic here or use `unimplemented` if not implemented
        throw this.unimplemented('In-app purchases not available on web');
    }
    async purchaseProduct() {
        // Implement the purchaseProduct logic here or use `unimplemented` if not implemented
        throw this.unimplemented('In-app purchases not available on web');
    }
}
//# sourceMappingURL=web.js.map